import React, {useEffect, useState} from 'react';
import Column from "@amzn/meridian/column";
import { css } from "emotion";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Card from "@amzn/meridian/card";
import StowSummaryView from "./StowSummaryView";
import {getRedirectFromModule} from "../../utils/Utils";
import {getConsentStatus, updateConsentStatus, isRedirectFromModuleValid, exitModule} from "./NetworkUtils";
import {Loader} from "@amzn/dolphin-uiweb-framework";
import { AnalyticEventKeys, MobileAnalyticsHelper, DataHandler } from "@amzn/dolphin-web-framework";
import { ANALYTICS_DESCRIPTION } from "../../../constants/AnalyticsConstants";
import { CONSENT_STATUS, USER_RESPONSE, REDIRECT_FROM_MODULE, EXPERIMENT_STATUS} from "./Constants";

const SummaryView = (props) => {

    const redirectFromModule = getRedirectFromModule();
    const [consentStatus, setConsentStatus] = useState(null);
    const [isUserSelectedToAskLater, setIsUserSelectedToAskLater] = useState(false);
    const [experimentStatus, setExperimentStatus] = useState(null);

    const centerAlignText = css({
        textAlign: "center"
    });

    const linkText = css({
        padding: "0px",
        color: "#077398",
        textDecoration: "underline",
        textDecorationColor: "#077398"
    });

    useEffect(() => {
        if (!isRedirectFromModuleValid(redirectFromModule)) {
            exitModule();
        } else {
            getConsentStatus(redirectFromModule, setConsentStatus, setExperimentStatus);
        }
    }, []);

    const onAcceptConsentButtonClick = () => {
        sendConsentAnalytics(USER_RESPONSE.CONSENTED);
        updateConsentStatus(redirectFromModule, true, setConsentStatus);
    }

    const onAskMeLaterButtonClick = () => {
        sendConsentAnalytics(USER_RESPONSE.ASK_ME_LATER);
        setIsUserSelectedToAskLater(true);
    }

    const onDeclineConsentButtonClick = () => {
        sendConsentAnalytics(USER_RESPONSE.DECLINED);
        updateConsentStatus(redirectFromModule, false, setConsentStatus);
    }

    const renderConsentOptions = () => {
        return (
            <Card width={"100%"} spacingInset={"200"}>
                <Column>
                    <Row widths={["grid-12"]} alignmentHorizontal={"center"} width={"100%"} id={"info-icon-row"}>
                        <Box>
                            <Text className={centerAlignText}>{`Show me my shift summary`}</Text>
                        </Box>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} alignmentHorizontal={"center"} width={"100%"} id={"info-icon-row"}>
                        <Button onClick={onAcceptConsentButtonClick}>Accept</Button>
                        <Button onClick={onAskMeLaterButtonClick} type={"secondary"}>Ask me later</Button>
                    </Row>
                    <Row alignmentHorizontal={"end"} width={"100%"}>
                        <span onClick={onDeclineConsentButtonClick}><Text type={"b200"} className={linkText}>{`Don't ask me again`}</Text></span>
                    </Row>
                </Column>
            </Card>
        )
    }

    const sendConsentAnalytics = (response) => {
        MobileAnalyticsHelper.processAnalytics( Date.now(), ANALYTICS_DESCRIPTION.SUMMARY_CONSENT_RESPONSE, response,
            AnalyticEventKeys.Modules.MY_INSIGHT, JSON.stringify({response: response, moduleType: redirectFromModule }),
            DataHandler.getUserEmployeeId(), AnalyticEventKeys.Events.USER_SELECTED_CONSENT_OPTION, false, null, null);
    };

    const renderSummaryView = () => {

        // Display nothing until consent status is not fetched.
        if (!consentStatus) {
            return <Loader/>;
        }

        // Exit from module if user asked to remind him/her later.
        if (isUserSelectedToAskLater) {
            exitModule();
        }

        // If user is in the CONTROL group, exit the module
        if (experimentStatus === EXPERIMENT_STATUS.CONTROL) {
            exitModule();
        }

        if (consentStatus === CONSENT_STATUS.NOT_FOUND) {
            return (
                    renderConsentOptions()
            );
        } else if (consentStatus === CONSENT_STATUS.CONSENTED) {
             if (redirectFromModule === REDIRECT_FROM_MODULE.STOW) {
                return (
                    <StowSummaryView {...props} />
                );
            }
        }

        // Exit from module if consent status is DECLINED or anything else.
        exitModule();
    }

    return (
        <Column width={"100%"} height={"100%"} spacingInset={"small"} alignmentVertical={"center"}>
            {renderSummaryView()}
        </Column>
    )
}

export default SummaryView;
